import { COPYRIGHT_SHORT } from "../../../utils/copyrightNotice";
import { Box, Brand, BODY_INK, CroppedImage, INK, LogoAt, Page, pt, Text } from "../primitives";
/**
 * «الخيار N» page (Arabic master template, page 19) — an artwork page of
 * layout "option": the artwork image on the left half, «الخيار N» + title
 * (page.caption) + description (page.description) on the right.
 * N counts the option pages in order (ProposalDocument).
 */
export const OPTION_PANEL = { x: 0, y: 0, w: 562.5, h: 810 };

export function OptionPage({ page, number }) {
    const slot = page.slots[0];
    return (<Page>
      <Box {...OPTION_PANEL} style={{ background: "#000000", overflow: "hidden" }}>
        {slot?.image ? (<CroppedImage image={slot.image} crop={slot.crop} w={OPTION_PANEL.w} h={OPTION_PANEL.h}/>) : (<div className="doc-placeholder is-dark" style={{ background: "transparent" }}>
            <span className="doc-placeholder-label">الخيار {number}</span>
          </div>)}
      </Box>
      <LogoAt cx={73} cy={90} w={31} color="#ffffff"/>
      <Brand right={1064.4} top={63} size={33.4}/>

      <Text right={1065.2} top={507.8} size={17.4} weight={700} color={INK}>
        الخيار {number}
      </Text>
      {page.caption && (<Text right={1065.2} top={536.9} size={17.4} weight={500} color={INK}>
          {page.caption}
        </Text>)}
      {page.description && (<Text right={1065.2} top={581.3} size={17.4} weight={300} color={BODY_INK} width={460} wrap style={{ lineHeight: pt(29), whiteSpace: "pre-line" }}>
          {page.description}
        </Text>)}
      {/* ©️ نفس سطر الحقوق بصفحات اللوحات (SuggestedArtworkPage.jsx) - بنص الجهة البيضاء */}
      <Text center={843.75} top={788} size={8} weight={400} color="#ffffff" style={{ background: "rgba(0,0,0,0.45)", padding: `${pt(2)} ${pt(10)}`, borderRadius: pt(8) }}>
        © {COPYRIGHT_SHORT}
      </Text>
    </Page>);
}
